import { injectable } from 'tsyringe';
import { OWInternalExtensions } from '../../odk-internal-ts/ow-internal-extensions';
import { OWExtension } from '../../odk-ts';
// -----------------------------------------------------------------------------
// Testable wrapper for OWExtension
@injectable()
export class OWExtensionWrapper {
  private owExtension: OWExtension = null;

  // ---------------------------------------------------------------------------
  public get manifest(): overwolf.extensions.Manifest {
    return this.owExtension?.manifest;
  }

  // ---------------------------------------------------------------------------
  public async initialize() {
    this.owExtension = await OWExtension.fromCurrent();
  }

  // ---------------------------------------------------------------------------
  public async initializeForExtension(extensionId: string) {
    this.owExtension = await OWExtension.fromExtensionId(extensionId);
  }

  // ---------------------------------------------------------------------------
  public async changeExtensionEnableState(uid: string, enable: boolean) {
    await OWInternalExtensions.changeExtensionEnableState(uid, enable);
  }

  // ---------------------------------------------------------------------------
  public async addTemporarilyWhitelistedExtension(uid: string) {
    OWInternalExtensions.addTemporarilyWhitelistedExtension(uid);
  }

  // ---------------------------------------------------------------------------
  public async installAnyApp(uid: string) {
    await OWInternalExtensions.installAnyApp(uid);
  }

  // ---------------------------------------------------------------------------
  public async getDownloadedExtensions() {
    return OWInternalExtensions.getDownloadedExtensions();
  }

  // ---------------------------------------------------------------------------
  public async getInstalledAndEnabledExtensions() {
    const downloadedExtensions = await this.getDownloadedExtensions();

    return downloadedExtensions.filter((extension) => {
      return extension.is_installed && extension.is_enabled;
    });
  }

  // ---------------------------------------------------------------------------
  public async getInstalledAndEnabledExtensionUids() {
    const downloadedExtensions = await this.getDownloadedExtensions();

    return downloadedExtensions
      .filter((extension) => {
        return extension.is_installed && extension.is_enabled;
      })
      .map((ext) => ext.UID);
  }
}
